CustomTC.define('modules/chat/chat',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'modules/logger', 'text!modules/htmls/loading.html', 'text!modules/chat/htmls/chat.html', 'text!modules/chat/htmls/chat-input.html', 'css!modules/css/loading', 'css!modules/chat/css/chat'], function(util, core, config, constants, options, loadData, language, logger, loading, chat, chatInput) {
    return {
        name: '',
        colorName: '',
        huuid: '',
        uuid: '',
        colorArr: [],
        //init
        init: function(playerUI, video) {
            this.playerUI = playerUI;
            this.initializeChat();
        },
        // initialize chat
        initializeChat: function() {
            var self = this;
            //self.name = self.randomName();
            self.colorName = self.colorLuminance(self.randomColor('hex'), -0.2);
            this.video = options.videoInfo[0];
            var to = this.video.video_url.split('/');
            var UUID = to[to.length - 2];
            // add chat input container
            var chatInputContainer = core.init(chatInput);
            chatInputContainer.insertAfter('.space-placeholder');

            // show on ready
            var vPlayerEle = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
            self.setChatUsername();

            // post chat message
            var chatForm = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT_WRAPPER + ' form');
            core.off(chatForm, 'submit');
            core.on(chatForm, 'submit', function(e) {
                e.stopImmediatePropagation();
                self.postChatMessage();
                return false;
            });
            // post comment by send button
            var chatPostBtn = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT_WRAPPER + '> form a');
            core.off(chatPostBtn, 'touchstart click');
            core.on(chatPostBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.postChatMessage();
                return false;
            });

            // append chat container
            var chatContainer = core.init(chat);
            core.init('.' + constants.CSS_TOUCHCAST_PLAYER_TOOLS + ' .right-wrapper').append(chatContainer);
            // show hide chat
            var chatPostIcon = core.init('.' + constants.CSS_TOUCHCAST_CHAT_ICON + '');
            core.off(chatPostIcon, 'touchstart click');
            core.on(chatPostIcon, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var chatInput = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT_WRAPPER + '');
                var chatContainer = core.init('.' + constants.CSS_TOUCHCAST_CHAT_WRAPPER + '');
                var userChat = core.init('.' + constants.CSS_TOUCHCAST_USER_CHAT + '');
                //core.show(chatInput);
                if (core.hasClass(chatInput, constants.CSS_TOUCHCAST_HIDE)) {
                    core.removeClass(chatInput, constants.CSS_TOUCHCAST_HIDE);
                    core.removeClass(chatContainer, constants.CSS_TOUCHCAST_HIDE);
                    core.addClass(chatPostIcon, constants.CSS_TOUCHCAST_SELECTED);
                } else {
                    core.addClass(chatInput, constants.CSS_TOUCHCAST_HIDE);
                    core.addClass(chatContainer, constants.CSS_TOUCHCAST_HIDE);
                    core.setCss(userChat, {
                        'opacity': '0'
                    });
                    core.removeClass(chatPostIcon, constants.CSS_TOUCHCAST_SELECTED);

                }
                return false;
            });
            // this.playerUI._resizeChat();


        },
        // receive chat
        receiveChat: function(data) {
            var self = this;
            var chatWrapper = core.init('.' + constants.CSS_TOUCHCAST_CHAT_BOX + '');
            var myClass = ''
            if (data.huuid == self.huuid) {
                var myClass = 'tcMyChat';
                if (self.colorArr[data.huuid]) {
                    var color = self.colorArr[data.huuid];
                    self.colorArr[data.huuid] = color;
                } else {
                    var color = self.colorName;
                    self.colorArr[data.huuid] = color;
                }
            } else {
                if (options.getEnableDisableChatSound()) {
                    var chatAudio = new Audio(options.getChatSound());
                    chatAudio.play();
                }
                var myClass = '';
                if (self.colorArr[data.huuid]) {
                    var color = self.colorArr[data.huuid];
                } else {
                    var color = self.colorLuminance(self.randomColor('hex'), -0.2);
                    self.colorArr[data.huuid] = color;
                }
                core.init('.' + constants.CSS_TOUCHCAST_CHAT_ICON + '').addClass(constants.CSS_TOUCHCAST_NEW_CHAT_MESSAGE);
                setTimeout(function() {
                    core.init('.' + constants.CSS_TOUCHCAST_CHAT_ICON + '').removeClass(constants.CSS_TOUCHCAST_NEW_CHAT_MESSAGE);
                }, 2000);
            }
            var newMessage = core.init('<div class="tcUserChat tc-fade-out  ' + myClass + '"> <div class = "tcChatBubble" > <div class = "tcChatName" style="background:' + color + '"> ' + util.escapeHTML((data.username)) + ' </div> <p> ' + util.linkify(util.escapeHTML((data.comment))) + ' </p> </div>  </div>');
            core.hide(newMessage);
            setTimeout(function() {
                core.remove(newMessage);
            }, 6000);
            //core.append(chatWrapper, '<div class="tcUserChat fade-out ' + myClass + '"> <div class = "tcChatBubble" > <div class = "tcChatName" style="background:' + color + '"> ' + data.name + ' </div> <p> ' + self.linkify(data.message) + ' </p> </div> <div class = "tcChatTime" > ' + formattedTime + ' </div> </div>');
            core.append(chatWrapper, newMessage);
            core.slideDown(newMessage);
        },
        setChatUsername: function() {
            var self = this;
            if (interactiveLayerConfig.livestream_comment_user) {
                self.name = interactiveLayerConfig.livestream_comment_user.name;
                self.huuid = interactiveLayerConfig.livestream_comment_user.huuid;
                self.uuid = interactiveLayerConfig.livestream_comment_user.uuid;
            }
            if (!util.checkIfLiveInteractivitySafariSupported()) {
                self.playerUI.initModal();
                //var nonInteractiveMsg = 'You can watch this TouchCast live stream in this browser but to interact with the video we recommend switching to a modern, desktop browser.';
                //self.playerUI.showNonInteractivePopup();
            }
        },
        // post chat message
        postChatMessage: function() {
            var self = this;
            var chatInput = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT + '');
            var chatText = core.trim(core.getVal(chatInput));
            if (chatText != '') {
                var vPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
                var timeChat = vPlayer.currentTime;
                interactiveLayerConfig.livestream_handler.commentPost(chatText, timeChat, function(data) {
                    logger.log('Post message', data);
                });
                //self.receiveChat(data);
                core.setVal(chatInput, '');
            }
        },
        // random color
        randomColor: function(format) {
            var rint = Math.round(0xffffff * Math.random());
            switch (format) {
                case 'hex':
                    return ('#0' + rint.toString(16)).replace(/^#0([0-9a-f]{6})$/i, '#$1');
                    break;
                case 'rgb':
                    return 'rgb(' + (rint >> 16) + ',' + (rint >> 8 & 255) + ',' + (rint & 255) + ')';
                    break;
                default:
                    return rint;
                    break;
            }
        },
        //color luminosity
        colorLuminance: function(hex, lum) {
            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '');
            if (hex.length < 6) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
            }
            lum = lum || 0;

            // convert to decimal and change luminosity
            var rgb = "#",
                c, i;
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i * 2, 2), 16);
                c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                rgb += ("00" + c).substr(c.length);
            }
            return rgb;
        }
    }
});
